<!-- Incluir clase "active" según corresponda -->
<div
  class="tabs mobile"
  [ngClass]="{
    w4: isDealWithInsurance && isAvailableInsurancePayments,
    w3: isDealWithInsurance && !isAvailableInsurancePayments,
    w2: !isDealWithInsurance
  }"
>
  <a (click)="selectSection(1)" [ngClass]="{ active: showSection == 1 }">Información contractual</a>
  <!-- <a (click)="selectSection(2)" [ngClass]="{'active': showSection == 2}">Pagos especiales</a> -->
  <a (click)="selectSection(3)" [ngClass]="{ active: showSection == 3 }">Amortizaciones ({{ currencySelected() }})</a>
  @if(isDealWithInsurance){
  <a (click)="selectSection(4)" [ngClass]="{ active: showSection == 4 }">Seguro</a>
  } @if(isAvailableInsurancePayments){
  <a (click)="selectSection(5)" [ngClass]="{ active: showSection == 5 }"
    >Amortizaciones Seguro ({{ currencySelected() }})</a
  >
  }
</div>

<!-- Información contractural -->
<div class="contractMobile" *ngIf="showSection == 1">
  <!-- Parámetros -->
  <div class="parameters">
    <div class="general">
      <!-- Producto financiero -->
      <div class="row">
        <label>Producto financiero</label>
        <span>{{ financialCalculator.getFinancialProduct(_deal.financialProductType) }}</span>
      </div>

      <!-- Plazo -->
      <div class="row">
        <label>Plazo</label>
        <div>
          <span>{{ _deal.term }}</span>
          <span> Meses</span>
        </div>
      </div>

      <!-- Segmento OPEX -->
      <div class="row">
        <label>Segmento OPEX</label>
        <span>{{ financialCalculator.getSegmentOpex(_deal.opexSegment) }}</span>
      </div>

      <!-- Moneda -->
      <div class="row">
        <label>Moneda</label>
        <span>{{ _deal.currencyType }}</span>
      </div>

      <!-- Cotización-->
      <div class="row">
        <label>Cotización USD</label>
        <span>{{ _deal.quoteUsd }}</span>
      </div>

      <!-- IVA -->
      <div class="row">
        <label>IVA</label>
        <div>
          <span>{{ _deal.tax }}</span>
          <span>%</span>
        </div>
      </div>

      <!-- Exento IVA -->
      <div class="row">
        <label>Exento IVA</label>
        <span>{{ !getTaxFree(_deal) ? 'NO' : 'SI' }}</span>
      </div>

      @if (featureLoyaltyFeriaQuotation) {
      <div class="row">
        <label>Loyalty (propuesta)</label>
        <span>{{ dealLoyaltyReadonlyYesNo() }}</span>
      </div>
      }

      <!-- Tasa al cliente -->
      <div class="row">
        <label>Tasa al cliente</label>
        <div>
          <span>{{ _deal.customerRate }}</span>
          <span>%</span>
        </div>
      </div>
    </div>

    <div class="vehicle">
      <!-- Imagen -->
      @if(!isManualInsurance()){
      <div class="photo">
        @if (subBrandImg; as imgUrl) {
        <!-- Si tiene imagen mostrar picture -->
        <picture>
          <img src="{{ imgUrl }}" alt="Marca Submarca" />
        </picture>
        } @else {
        <!-- Si no tiene imagen mostrar -->
        <div class="noImage">
          <span>Sin imagen</span>
        </div>
        }
      </div>
      }

      <!-- Tipo de poducto -->
      <div class="row">
        <label>Tipo de producto</label>
        <span>{{ financialCalculator.getProductType(_deal.productType) }}</span>
      </div>

      <!-- Condición -->
      <div class="row">
        <label>Condición</label>
        <span>{{ !_deal.classification ? 'No aplica' : _deal.classification == 'NEW' ? 'Nuevo' : 'Usado' }}</span>
      </div>

      <!-- Tiempo de uso -->
      @if(_deal.useTime){
      <div class="row">
        <label>Tiempo de uso</label>
        <div>
          <span>{{ _deal.useTime }}</span>
          <span> Meses</span>
        </div>
      </div>
      } @if(isDealWithInsurance){
      <!-- Año -->
      @if(!isManualInsurance()){
      <div class="row">
        <label>Año</label>
        <span>{{ model?.year }}</span>
      </div>
      }

      <!-- Modelo -->
      @if(!isManualInsurance()){
      <div class="row">
        <label>Modelo</label>
        <span>{{ model?.name }}</span>
      </div>
      } }

      <!-- Cantidad -->
      <div class="row">
        <label>Cantidad</label>
        <span>{{ _deal.quantity }}</span>
      </div>

      @if(!isManualInsurance()){
      <!-- Marca -->
      <div class="row">
        <label>Marca</label>
        <span>{{ brand?.name }}</span>
      </div>

      <!-- Submarca -->
      <div class="row">
        <label>Submarca</label>
        <span>{{ subBrand?.name }}</span>
      </div>
      }

      <!-- Caracteristicas -->
      @if( _deal.feature){
      <div class="row">
        <label>Caracteristicas</label>
        <span>{{ _deal.feature }}</span>
      </div>
      }
    </div>

    <div class="conditions">
      <!-- Precio unitario -->
      <div class="row group">
        <label>Precio unitario</label>

        <div class="innerRow">
          <label>Sin IVA</label>
          <div>
            <span>{{ _deal.unitPriceWithoutTax | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>
        <div class="innerRow">
          <label>Con IVA</label>
          <div>
            <span>{{ _deal.unitPriceWithTax | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Total venta -->
      <div class="row group">
        <label>Total venta</label>

        <div class="innerRow">
          <label>Sin IVA</label>
          <div>
            <span>{{ _deal.totalPriceWithoutTax | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>

        <div class="innerRow">
          <label>Con IVA</label>
          <div>
            <span>{{ _deal.totalPriceWithTax | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Enganche -->
      <div class="row group" *ngIf="_deal.financialProductType != financialProduct.pureLease">
        <div class="labelAndData">
          <label>Enganche</label>
          <div>
            <label>{{ financialCalculator.getTaxType(_deal.downPaymentTaxType) }}</label>
            <span>{{ _deal.downPaymentTax }}</span>
            <span *ngIf="_deal.downPaymentTax">%</span>
          </div>
        </div>

        <div class="innerRow">
          <label>Sin IVA</label>
          <div>
            <span>{{ _deal?.result?.downpaymentAmount / (1 + _deal?.tax / 100) | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>

        <div class="innerRow">
          <label>Con IVA</label>
          <div>
            <span>{{ _deal?.result?.downpaymentAmount | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!isInsurance()">
        <!-- <div class="parameters"></div> -->
      </ng-container>

      <ng-container *ngIf="isInsurance()">
        <div class="parameters"></div>
        <div class="parameters"></div>
      </ng-container>

      <!-- Monto a financiar -->
      <div class="row">
        <div class="labelAndData">
          <label>Monto a financiar</label>
          <div>
            <span>{{ (_deal?.result?.financialAmount ?? _deal?.financialAmount) | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Comisión por apertura -->
      <div class="row group">
        <div class="labelAndData">
          <label>Comisión por apertura</label>
          <div>
            <label>{{ financialCalculator.getTaxType(_deal.openingFeeType) }}</label>
            <span>{{ _deal.openingFeePercentage }}</span>
            <span *ngIf="_deal.openingFeePercentage">%</span>
          </div>
        </div>

        <div class="innerRow">
          <label>Sin IVA</label>
          <div>
            <span>{{ _deal?.result?.openingfeeAmount / (1 + _deal.tax / 100) | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>

        <div class="innerRow">
          <label>Con IVA</label>
          <div>
            <span>{{ _deal?.result?.openingfeeAmount | currency : '' : '' }}</span>
            <span>{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Depósitos en garantía -->
      <div class="row group">
        <label>Depósitos en garantía</label>

        <div class="innerRow">
          <label>{{ financialCalculator.getTaxType(_deal.warrantyDeposit) }}</label>
          <div>
            <span>{{
              _deal.warrantyDeposit == taxType.numberOfRents
                ? _deal.warrantyDepositMonth
                : (_deal.warrantyDepositTotal | currency : '' : '')
            }}</span>
            <span *ngIf="_deal.warrantyDepositTotal || _deal.warrantyDepositMonth">{{
              _deal.warrantyDeposit == taxType.numberOfRents ? 'Mensualidades' : currencySelected()
            }}</span>
          </div>
        </div>
      </div>

      <!-- Subsidio -->
      <div class="row group">
        <div class="labelAndData">
          <label>Subsidio</label>

          <div *ngIf="_deal.subsidyTotal; else notApply">
            <label>{{ financialCalculator.getTaxType(_deal.subsidyType) }}</label>
            <span>{{ _deal.subsidyPercentage }}</span>
            <span *ngIf="_deal.subsidyPercentage">%</span>
          </div>
          <ng-template #notApply>
            <span>No aplica</span>
          </ng-template>
        </div>

        <div *ngIf="_deal.subsidyTotal; else notApply" class="innerRow">
          <label></label>
          <div>
            <span>{{ _deal.subsidyTotal | currency : '' : '' }}</span>
            <span *ngIf="_deal.subsidyTotal">{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Valor residual -->
      <div class="row group" *ngIf="_deal.financialProductType == financialProduct.pureLease">
        <div class="labelAndData">
          <label>Valor residual</label>

          <div>
            <label>{{ financialCalculator.getTaxType(_deal.residualValueType) }}</label>
            <span>{{ _deal.residualValuePercentage }}</span>
            <span *ngIf="_deal.residualValuePercentage">%</span>
          </div>
        </div>

        <div class="innerRow">
          <label></label>
          <div>
            <span>{{ _deal.residualValueTotal | currency : '' : '' }}</span>
            <span *ngIf="_deal.residualValueTotal">{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Opción de compra -->
      <div class="row group" *ngIf="_deal.financialProductType == financialProduct.financialLeasing">
        <div class="labelAndData">
          <label>Opción de compra</label>

          <div>
            <label>{{ financialCalculator.getTaxType(_deal.purchaseOptionType) }}</label>
            <span>{{ _deal.purchasePercentage }}</span>
            <span *ngIf="_deal.purchasePercentage">%</span>
          </div>
        </div>
        <div class="innerRow">
          <label></label>
          <div>
            <span>{{ _deal.purchaseTotal | currency : '' : '' }}</span>
            <span *ngIf="_deal.purchaseTotal">{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Tipo de pago -->
      <div class="row">
        <div class="labelAndData">
          <label>Tipo de pago</label>
          <span>{{ _deal.paymentType == 'REGULAR_PAYMENT' ? 'Anticipado' : 'Vencimiento' }}</span>
        </div>
      </div>
      <!-- Forma de amortización -->
      <div class="row">
        <div class="labelAndData">
          <label>Forma de amortización</label>
          <span>{{ _deal.paymentFormationType == 'LEVELED' ? 'Nivelada' : 'Descendente' }}</span>
        </div>
      </div>

      <!-- Gastos de ratificación -->
      <div class="row">
        <div class="labelAndData">
          <label>Gastos de ratificación</label>
          <div>
            <span>{{ _deal.confirmationExpensesAmount | currency : '' : '' }}</span>
            <span *ngIf="_deal.confirmationExpensesAmount">{{ currencySelected() }}</span>
          </div>
        </div>
      </div>

      <!-- Factor seguro de vida -->
      <div class="row">
        <label>Factor seguro de vida</label>
        <span>{{ _deal.lifeInsuranceFactor | currency : '' : '' }}</span>
      </div>

      <!-- Colateral adicional -->
      <div class="row" *ngIf="_deal.financialProductType == financialProduct.directCredit">
        <label>Colateral adicional</label>
        <div *ngIf="_deal.additionalCollateralTotal; else notApply">
          <div>
            <span>{{ financialCalculator.getTaxType(_deal.additionalCollateralType) }}</span>
            <span>{{ _deal.additionalCollateralPercentage }}</span>
            <span *ngIf="_deal.additionalCollateralPercentage">%</span>
          </div>
          <div>
            <span>{{ _deal.additionalCollateralTotal | currency : '' : '' }}</span>
            <span *ngIf="_deal.additionalCollateralTotal">{{ currencySelected() }}</span>
          </div>
        </div>
        <ng-template>
          <div>
            <span>No aplica</span>
          </div>
        </ng-template>
      </div>
    </div>
    @if(isDealWithInsurance){
    <div class="insurance">
      <h3>Seguro</h3>

      <!-- Tipo de seguro -->
      @if(insuranceType){
      <div class="row">
        <label>Tipo de seguro</label>
        <span>{{ insuranceType.description }}</span>
      </div>
      }
      <!-- Estado -->
      @if(insurance?.stateName; as stateName){
      <div class="row">
        <label>Estado</label>
        <span>{{ stateName.toLowerCase() }}</span>
      </div>
      }
      <!-- Uso -->
      @if(insuranceUse){
      <div class="row">
        <label>Uso</label>
        <span>{{ insuranceUse.description }}</span>
      </div>
      } @if(loadType){
      <div class="row">
        <label>Tipo de carga</label>
        <span>{{ loadType }}</span>
      </div>
      } @if(insurance?.quantityPassengers; as quantity){
      <div class="row">
        <label>Cantidad de pasajeros</label>
        <span>{{ quantity }}</span>
      </div>
      }
    </div>
    }
  </div>
</div>

<!-- Amortizations -->
<div *ngIf="showSection == 3">
  <app-payments-mobile
    [payments]="_deal.payments"
    [quantity]="_deal.quantity"
    [currency]="currency"
    [readOnly]="true"
    [specialPayments]="_deal.specialPayments"
    [grace]="_deal.grace"
    [irregularPayments]="_deal.irregularPayments"
    [tipoProductoFinanciero]="_deal.financialProductType"
  >
  </app-payments-mobile>
</div>

<div *ngIf="showSection == 4">
  <app-insurance-list-payments-mobile
    [coverage]="insurance"
    [quantity]="_deal.quantity"
  ></app-insurance-list-payments-mobile>
</div>

<div *ngIf="showSection == 5">
  <app-insurance-amortizations-mobile
    [payments]="insurancePayments"
    [quantity]="_deal.quantity"
    [currency]="currency"
    [readOnly]="true"
    [tipoProductoFinanciero]="_deal.financialProductType"
    [grace]="_deal.grace"
  ></app-insurance-amortizations-mobile>
</div>
